import { findIndex, isEmpty, isNil, omitBy } from 'lodash'
import i18n from 'i18next'
import { isKeyOf } from '@ahha/utils/@types/typeChecks'
import { WidgetPreset } from '@/pages/DataCamp/Dashboard/const'

export const getWidgetTitle = (widgetType: number): string => {
  if (widgetType === WidgetPreset.LINE_CHART) {
    return i18n.t('widget_type_lineChart')
  }
  if (widgetType === WidgetPreset.BAR_CHART) {
    return i18n.t('widget_type_barChart')
  }
  if (widgetType === WidgetPreset.PIE_CHART) {
    return i18n.t('widget_type_pieChart')
  }
  if (widgetType === WidgetPreset.TABLE) {
    return i18n.t('common_table')
  }
  if (widgetType === WidgetPreset.IMAGE) {
    return i18n.t('common_image')
  }
  if (widgetType === WidgetPreset.TEXT) {
    return i18n.t('common_text')
  }
  return i18n.t('widget_type_container')
}

export const checkIsOnlyDigits = (value: string) => {
  const regex = /^[0-9]*$/
  return regex.test(value)
}

export const limitDecimalPlaces = (value: string | number, decimalPlace: number) => {
  const stringValue = String(value)
  if (isEmpty(stringValue)) {
    return ''
  }
  if (stringValue.substring(stringValue.indexOf('.')).length > decimalPlace + 1) {
    return Number(stringValue.slice(0, -1))
  }
  return Number(value)
}

export const searchDictionary = (dictionary: Record<string, string>, search: string) => {
  if (isKeyOf(search, dictionary)) {
    return dictionary[search]
  }
  return null
}

export const getTotalPage = (totalCount: number | undefined, itemsPerPage: number) => Math.ceil((totalCount ?? itemsPerPage) / itemsPerPage)

export const omitNilOrEmptyStringFromObject = (obj: { [key: string]: any }) => omitBy(obj, (o) => isNil(o) || o === '')

export const getCheckpointNumber = (weightScores: Record<string, any>[] | undefined, targetWeight: Record<string, any>| undefined) => {
  if (!weightScores || !targetWeight) {
    return undefined
  }
  const targetIndex = findIndex(weightScores, targetWeight)
  return `Top ${targetIndex + 1}`
}

export const sanitizeFileName = (fileName: string) => (
  fileName
    .replace(/[<>:"|?*]/g, '_') // Replace forbidden characters (windows 기준)
    .replace(/\//g, '_') // Replace forward slash
    .replace(/\\/g, '_') // Replace backslash
    .replace(/\s+/g, '_') // replace spaces with underscores
    .trim()
)
